import { computed } from 'vue'
import { useStore } from 'vuex'

export function useOrgMembership() {
  const store = useStore()
  const selectedOrg = computed(() => store.getters['org/getSelectedOrg'])

  const isOrgMember = computed(() => selectedOrg.value?.is_member ?? false)
  const orgName = computed(() => selectedOrg.value?.organization_name ?? '')

  return { isOrgMember, orgName, selectedOrg }
}
